<template>
  <div class="wrapper-content w-100">
    <h1>{{title}}</h1>
    <LmBreadcrumb />
    <h4 v-if="expediente.numeroExpediente">Para el Tramite: {{expediente.numeroExpediente}}</h4>
    <LmForm ref="lmFormRef">
      <div class="row">
        <LmSuperPowerSelect
          class="col-12 col-lg-6"
          :data="lmSuperPowerSelects.oficinaDestino.selectOptions"
          :tbColumns="lmSuperPowerSelects.oficinaDestino.tbColumns"
          label="Oficina Destino"
          title="Oficina Destino"
          placeholder="Oficina Destino"
          @values="updateOficinaDestino"
          :v="$v.form.oficinaDestino"
        />
      </div>
      <LmButton
        v-if="enableGoBackButton"
        type="button"
        buttonClass="btn-secondary"
        :value="$t('go_back')"
        @click.native="goBackBtn"
        lmButtonRootWrapperClass="d-inline-block"
        lmButtonWrapperClass="col"
      />
      <LmButton
        v-if="!enableGoBackButton"
        type="button"
        buttonClass="btn-secondary"
        :value="$t('Cancel')"
        @click.native="cancelBtn"
        lmButtonRootWrapperClass="d-inline-block"
        lmButtonWrapperClass="col"
      />
      <LmButton
        v-if="!enableGoBackButton"
        type="submit"
        buttonClass="btn-primary"
        :isProcessing="formIsProcessing"
        :value="$t('Save')"
        lmButtonRootWrapperClass="d-inline-block ml-1"
        lmButtonWrapperClass="col"
        @click.native="submit"
      />
    </LmForm>
    <lmConfirmationModal ref="lmConfirmationModal" title="Aviso" message="Está seguro que desea realizar un nuevo pase?"/>
  </div>
</template>

<script>
import commonsApi from '@/api/commons'
import { mapState, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LmForm from '@/components/form/LmForm.vue'
import LmButton from '@/components/form/elements/LmButton'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
import lmConfirmationModal from '@/components/modals/LmConfirmationModal'

export default {
  mixins: [lmSuperPowerSelectHelper],
  components: {
    LmForm,
    LmSuperPowerSelect,
    LmButton,
    lmConfirmationModal
  },
  data () {
    return {
      lmSuperPowerSelects: {
        oficinaDestino: {
          selectOptions: [],
          tbColumns: [
            { title: 'Oficina', data: 'name' }
          ]
        }
      },
      form: {
        oficinaDestino: '',
        idOficinaDestino: ''
      },
      expediente: {},
      formIsProcessing: false
    }
  },
  computed: {
    ...mapState('commons', ['itemDetail'])
  },
  props: {
    title: {
      type: String,
      required: true
    },
    onSuccessDestinationRoute: {
      type: String,
      required: true,
      default: '/'
    },
    newOrEditEndpointUri: {
      type: String,
      required: true
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  validations: {
    form: {
      oficinaDestino: {
        required
      }
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings']),
    ...mapActions('session', ['getUserInfo']),
    goBackBtn () {
      this.$router.push(`${this.onSuccessDestinationRoute}/${this.$route.params.id}`)
    },
    cancelBtn () {
      this.$router.push(`${this.onSuccessDestinationRoute}/${this.$route.params.id}`)
    },
    async submit () {
      try {
        await this.$refs.lmConfirmationModal.lmShow()
        await this.$refs.lmFormRef.validationForm(this.$v)
        this.formIsProcessing = true
        /**
         * Se persisten los datos
         */
        let saveData = {
          id: this.$route.params.id,
          idOficinaDestino: this.form.idOficinaDestino
        }
        try {
          await this.updateItemDetail({
            path: 'pases/new/',
            data: saveData
          })
          this.formIsProcessing = false
          this.$router.push(`/tramites/pases/delexpediente/${this.$route.params.id}`)
        } catch (error) {
          this.formIsProcessing = false
          if (error.response && error.response.status === 400) {
            this.$bvToast.toast(error.response.data.message, {
              title: 'Error',
              toaster: 'b-toaster-bottom-center',
              variant: 'danger',
              solid: true
            })
          } else {
            this.$bvToast.toast(this.$t('try_again_later'), {
              title: 'Error',
              toaster: 'b-toaster-bottom-center',
              variant: 'danger',
              solid: true
            })
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    updateOficinaDestino (values) {
      const isThereValue = values.length
      const value = values[0]
      this.form.idOficinaDestino = isThereValue ? value.id : ''
      this.form.oficinaDestino = isThereValue ? value.name : ''
    },
    sanitizeModel (model) {
      return model ? model.toString() : ''
    }
  },
  mounted () {
    (async () => {
      try {
        this.$refs.lmFormRef.showLoading()
        this.expediente = await commonsApi.getItemDetail({
          path: 'expedientes/activos/edit/',
          id: this.$route.params.id
        })
        this.$refs.lmFormRef.hideLoading()
      } catch (error) {
        console.log(error)
        this.$router.replace({ name: '404' })
      }
    })()

    this.getAllLmSuperPowerSelectOptions([
      {
        name: 'oficinaDestino',
        obj: {
          path: 'oficinas/predictivo/',
          total: 1000
        }
      }
    ]).then(response => {
      response.forEach(async element => {
        const e = await element
        this.lmSuperPowerSelects[e.name].selectOptions = e.data
      })
    })
  }
}
</script>

<style lang="sass" scoped>
  hr
    border-top: 2px solid !important
    margin-top: 50px !important
    margin-bottom: 20px !important
  h4, h5
    margin-bottom: 30px !important
</style>
